import ErrorAlert from "@/utility/ErrorAlert";
import InterfacePemeriksaanFisikRalan from "@/apiInterface/InterfacePemeriksaanFisikRalan";

class DataPemeriksaanFisikRalan {
  async getDataPemeriksaanFisikRalan(unit, reg) {
    let dt: any
    await InterfacePemeriksaanFisikRalan.getPemeriksaanFisikRalan(unit, reg).then((response) => {
      dt = response.data
    })
      .catch((e) => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Pemeriksaan Fisik Ralan")
      });
    return dt
  }


  async saveDataPemeriksaanFisikRalan(
    reg,
    unit_id,
    rm,
    param
  ) {
    let dt: object = {}
    await InterfacePemeriksaanFisikRalan.savePemeriksaanFisikRalan(
     reg,
      unit_id,
      rm,
      param
    ).then((response) => {
      dt = response.data
    })
      .catch((e) => {
        dt = e.response
        ErrorAlert.showErrorAlert(e)
      });
    return dt
  }

  async editDataPemeriksaanFisikRalan(
    reg,
    unit_id,
    rm,
    param
  ) {
    let dt: object = {}
    await InterfacePemeriksaanFisikRalan.editPemeriksaanFisikRalan(
      reg,
      unit_id,
      rm,
      param
    ).then((response) => {
      dt = response.data
    })
      .catch((e) => {
        dt = e.response
        ErrorAlert.showErrorAlert(e)
      });
    return dt
  }
}

export default new DataPemeriksaanFisikRalan();